<script setup lang="ts">

const props = defineProps<{
  invertData?: any
}>();

const emits = defineEmits(['go'])

</script>

<template>
  <div class="invert-card common-card">
    <div class="icon">
      <div class="image-container">
        <img src="@/assets/images/renewal/inverter_white.svg" />
      </div>

      <button 
        type="button" 
        class="common-btn__gray" 
        @click="emits('go')"
      >
        이동하기
      </button>
    </div>

    <div class="equip-info-wrapper d-flex align-items-center">
      <div class="equip-info">
        <div class="name">{{ props.invertData.name ? props.invertData.name :'-' }}</div>
        <div class="capacity">설비용량 {{props.invertData.capacity ? props.invertData.capacity : '-'}}kW</div>
      </div>

      <div class="equip-prod">
        <div class="today">금일 발전량</div>
        <div class="prod">
          {{ props.invertData.todayProd ? props.invertData.todayProd : '-' }}
          <span class="unit">kWh</span>
        </div>
      </div>

      <div class="equip-status">
        <div class="status">{{ props.invertData ? props.invertData.status : '-' }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/invert-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";
@use "@/assets/styles/design-toc/common-button.scss";

</style>